import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
//   FormControl,
//   Select,
//   MenuItem,
  TextField,
  Button,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import succsess from "assets/icons/success.svg";
import { createDriverAnnouncementNotification } from "services/pushNotification";
import { useTranslation } from "react-i18next";

export const useRTL = () => {
    const { t, i18n } = useTranslation();
    return { t, i18n };
  };

const NotificationForm = () => {
    const { t, i18n } = useRTL();

    const validationSchema = Yup.object({
        // targetAudience: Yup.string().required(t("requiredField")),
        notificationTitle: Yup.string().required(t("requiredField")),
        notificationBody: Yup.string().required(t("requiredField")),
    });

    const [openSuccess, setOpenSuccess] = useState(false);

    const formik = useFormik({
        initialValues: {
            targetAudience: "",
            notificationTitle: "",
            notificationBody: "",
        },
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                const payload = {
                    title: values.notificationTitle,
                    content: values.notificationBody,
                };
                await createDriverAnnouncementNotification(payload);
                resetForm();
                setOpenSuccess(true);

            } catch (error) {
                console.error(error);

            }
        },
    });




    const handleCloseSuccess = () => {
        setOpenSuccess(false);
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>

                {/* this code is for target audiance ( all drivers , approved  driver ) select box commited untill it's ready to  use it  */}
                {/* <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "2rem" }}>
                    <FormControl
                        variant="outlined"
                        sx={{
                            minWidth: 160,
                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                        }}
                        error={
                            formik.touched.targetAudience &&
                            Boolean(formik.errors.targetAudience)
                        }
                    >
                        <Select
                            id="targetAudience"
                            name="targetAudience"
                            value={formik.values.targetAudience}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            displayEmpty
                            renderValue={(selected) => {
                                if (!selected) {
                                    return (
                                        <span style={{ color: "#aaa" }}>
                                            {t("TargetAudience")}
                                        </span>
                                    );
                                }

                                switch (selected) {
                                    case "all":
                                        return t("AllDrivers");
                                    case "approved":
                                        return t("ApprovedDrivers");
                                    default:
                                        return selected;
                                }
                            }}
                        >

                            <MenuItem value="" sx={{ display: "none" }} />
                            <MenuItem value="all">{t("AllDrivers")}</MenuItem>
                            <MenuItem value="approved">{t("ApprovedDrivers")}</MenuItem>
                        </Select>
                    </FormControl>
                </Box> */}


                <Box sx={{ marginTop: "2rem", maxWidth: "700px" }}>
                    <Typography variant="subtitle1" sx={{ marginBottom: "0.5rem" }}>
                        {t("NotificationTitleLabel")}
                    </Typography>
                    <TextField
                        fullWidth
                        id="notificationTitle"
                        name="notificationTitle"
                        placeholder={t("NotificationTitle")}
                        variant="outlined"
                        value={formik.values.notificationTitle}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.notificationTitle &&
                            Boolean(formik.errors.notificationTitle)
                        }
                        helperText={
                            formik.touched.notificationTitle && formik.errors.notificationTitle
                        }
                        FormHelperTextProps={{
                            sx: {
                                marginLeft: 0,
                                marginRight: 0,
                                textAlign: i18n.language === "ar" ? "right" : "left",
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-input": {
                                padding: "10px 10px",
                            },
                        }}
                    />

                </Box>


                <Box sx={{ marginTop: "2rem", maxWidth: "700px" }}>
                    <Typography variant="subtitle1" sx={{ marginBottom: "0.5rem" }}>
                        {t("NotificationBodyLabel")}
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        id="notificationBody"
                        name="notificationBody"
                        placeholder={t("NotificationContent")}
                        variant="outlined"
                        value={formik.values.notificationBody}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.notificationBody &&
                            Boolean(formik.errors.notificationBody)
                        }
                        helperText={
                            formik.touched.notificationBody && formik.errors.notificationBody
                        }
                        FormHelperTextProps={{
                            sx: {
                                marginLeft: 0,
                                marginRight: 0,
                                textAlign: i18n.language === "ar" ? "right" : "left",
                            },
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        marginTop: "2rem",
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                    }}
                >
                    {/* this button is for draft save committed until it's implemented */}
                    {/* <Button
                        variant="text"
                        onClick={handleSaveDraft}
                        sx={{
                            color: "#2A346780",
                        }}
                    >
                        {t("SaveAsDraft")}
                    </Button> */}


                    <Button
                        type="submit"
                        variant="outlined"
                        sx={{
                            color: "#2A3467",
                            borderColor: "#2A3467",
                            padding: "8px 35px",
                            "&:hover": {
                                backgroundColor: "#2A3467",
                                color: "#fff",
                                borderColor: "#2A3467",

                            },
                        }}
                    >
                        {t("Publish")}
                    </Button>
                </Box>
            </form>

            <Dialog open={openSuccess} onClose={handleCloseSuccess} maxWidth="sm" fullWidth>
                <DialogContent>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        textAlign="center"
                        py={4}
                    >
                        <img
                            src={succsess}
                            alt="Success"
                            style={{ width: 200, marginBottom: "1rem" }}
                        />
                        <Typography variant="h5" gutterBottom>
                            {t("notificationSuccses")}
                        </Typography>
                        <Typography variant="body1">
                            {t("notificationDialogBody")}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        onClick={handleCloseSuccess}
                        variant="contained"
                        sx={{
                            color: "#2A3467",
                            backgroundColor: "#fff",
                            borderColor: "#2A3467",
                            padding: "8px 35px",
                            "&:hover": {
                                backgroundColor: "#2A3467",
                                color: "#fff",
                                borderColor: "#2A3467",

                            },
                        }}
                    >

                        {t("Close")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NotificationForm;
